import React, { Component } from "react";
import "./welcome.css";

class Welcome extends Component {
  state = {};
  render() {
    return (
      <div className="welcome">
        <div className="container-fluid contWelc">
          <div className="row">
            <div className="col-5">
              <h1 className="Welcome-to-your-acco">Welcome to your account</h1>
            </div>
            <div className="col-2 top offset-3">
              <h3 className="COMPLETE">PROFILE</h3>
              <h2 className="percent">100%</h2>
              <h3 className="COMPLETE toppp">COMPLETE</h3>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Welcome;
